import React from 'react';

const AddTransfer = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold text-gray-800">Add Transfer</h1>
      {/* Add your transfer form content here */}
    </div>
  );
};

export default AddTransfer; 